import apiClient from "../../core/apiClient";
import { SharedContactDTO, ShareContactResponse } from "../../interfaces/DTO/features/ShareContact";


const API_URL = "/share";

class ShareService {
  async shareContact(dto: SharedContactDTO): Promise<ShareContactResponse> {
    const response = await apiClient.post<ShareContactResponse>(`${API_URL}/contact`, dto);
    return response.data;
  }
}

export const shareService = new ShareService();
